import React from 'react';
import { DialogContainer } from '@adobe/react-spectrum';
import { ActionButton, Button } from '@react-spectrum/button';
import { Flex } from '@react-spectrum/layout';
import { View } from '@react-spectrum/view';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { analytics } from 'app/utils/analytics';
import { Capabilities } from 'app/utils/Capabilities';
import { errorNotifier } from 'app/utils/error';
import { hasSharing, share } from 'app/utils/sharing';
const Consts = {
    alwaysUseShareAlert: true,
};
const catchErrors = (promise) => promise.catch(error => {
    let reportError = true;
    if (error instanceof DOMException) {
        switch (error.name) {
            case 'AbortError':
                // user canceled share popup
                reportError = false;
                return;
            default:
                break;
        }
    }
    if (reportError) {
        errorNotifier(error, '[Share] Failed to present system share');
    }
});
const SystemShareAndroid = () => {
    const dispatch = useAppDispatch();
    const [render, setRender] = React.useState(null);
    const onShare = React.useCallback(() => {
        if (render) {
            catchErrors(share(render)).then(() => setRender(null));
        }
        else {
            analytics({
                action: 'ExportAction',
                label: 'share',
            });
            // NOTE: here we need to first generate image and only then present a share button
            dispatch(ProjectActions.rasterizeProject({ format: 'image/jpeg' }))
                .unwrap()
                .then(output => setRender(output));
        }
    }, [render, setRender, dispatch]);
    if (!hasSharing()) {
        return null;
    }
    const hasRender = Boolean(render);
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionButton, { onPress: onShare, isQuiet: true, isDisabled: hasRender }, "Share"),
        React.createElement(DialogContainer, { onDismiss: () => setRender(null) }, hasRender && (React.createElement(View, { padding: "size-200" },
            React.createElement(Flex, { direction: "column", gap: "size-400" },
                React.createElement(Button, { variant: "cta", onPress: onShare }, "Share your project"),
                React.createElement(Button, { variant: "negative", onPress: () => setRender(null) }, "Cancel")))))));
};
const SystemShareApple = () => {
    const dispatch = useAppDispatch();
    const onShare = React.useCallback(() => {
        analytics({
            action: 'ExportAction',
            label: 'share',
        });
        dispatch(ProjectActions.rasterizeProject({ format: 'image/jpeg' }))
            .unwrap()
            .then(output => catchErrors(share(output)));
    }, [dispatch]);
    if (!hasSharing()) {
        return null;
    }
    return (React.createElement(ActionButton, { onPress: onShare, isQuiet: true }, "Share"));
};
export const Share = () => Capabilities.shared.isAndroid || Consts.alwaysUseShareAlert ? (React.createElement(SystemShareAndroid, null)) : (React.createElement(SystemShareApple, null));
